import { Tracker } from '../components/Tracker.tsx';
import { useSquad } from '../state/useSquad.ts';

/** The watched-managers tracker's own route (T-048) — previously stacked
 * below the squad desk on every visit; now it only renders here. Reads the
 * loaded squad from context (mounted above the router in `main.tsx`) the
 * same way it always did, just without the squad desk's own markup around
 * it. */
export function TrackerRoute() {
  const { squad } = useSquad();
  return <Tracker squad={squad} />;
}
